import axios from 'axios';

const API_BASE = '/api/purchase-orders';

export const purchaseOrderService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  /** Preview next human-readable P.O. identifier (aligned to order when work_order_id is passed). */
  getNextIdentifierPreview: async ({ order_date, work_order_id } = {}) => {
    const params = {};
    if (order_date) params.order_date = order_date;
    if (work_order_id != null && work_order_id !== '') params.work_order_id = work_order_id;
    const response = await axios.get(`${API_BASE}/next-identifier-preview`, { params });
    return response.data;
  },

  getByPoNumber: async (poNumber) => {
    const response = await axios.get(`${API_BASE}/by-number/${encodeURIComponent(poNumber)}`);
    return response.data;
  },

  prefillFromOrder: async (workOrderId, lineItemIds = []) => {
    const params = {};
    if (Array.isArray(lineItemIds) && lineItemIds.length > 0) {
      params.line_item_ids = lineItemIds.join(',');
    }
    const response = await axios.get(`${API_BASE}/prefill-from-order/${workOrderId}`, { params });
    return response.data;
  },

  getShipmentsInForPO: async (poId) => {
    const response = await axios.get(`${API_BASE}/${poId}/shipments-in`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  }
};

